import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/routeRedirect";

// Legacy URL: answered with a real 301 on the server, preserving query and hash.
export const Route = createFileRoute("/privacy")({
  beforeLoad: permanentRedirect("/privacy-policy"),
});
